<template>
<div class="containers">
    <div>
        <div class="tui-box">
            <div>
                <div class="tui-address">
                    <div v-if="address.length > 0" class="address-main" @click="tabAddress">
                        <div class="flex align-center">
                            <img src="@/assets/icon/address.png" class="address-image" />
                            <div>
                                <div class="tui-userinfo">
                                    <span class="tui-name">{{
                      address[addressIndex].receiver_name
                    }}</span>
                                    {{ address[addressIndex].receiver_mobile }}
                                </div>
                                <div class="tui-addr">
                                    <span>{{ address[addressIndex].address.province
                      }}{{ address[addressIndex].address.city
                      }}{{ address[addressIndex].address.district
                      }}{{ address[addressIndex].address.line1 }}</span>
                                </div>
                            </div>
                        </div>
                        <img src="@/assets/icon/right.png" class="right-image" />
                    </div>
                    <div v-else class="address-main" @click="tabAddress">
                        <div class="flex align-center">
                            <img src="@/assets/icon/address.png" class="address-image" />
                            <span class="tui-none-addr">暂无收货地址，请先去添加收货地址</span>
                        </div>
                        <img src="@/assets/icon/right.png" class="right-image" />
                    </div>
                    <div class="tui-bg-img">
                        <img src="@/assets/icon/bottom.png" />
                    </div>
                </div>
            </div>

            <div class="tui-goods-info" data="productList">
                <div class="bg-white tui-top round-20" v-for="(shopItem, index) in shopInfo.shoppingCartSubInfoList" :key="index">
                    <!-- <div class="tui-goods-title">
              {{ shopItem.storeName }}
            </div> -->
                    <div v-for="(shopItemProduct,
              index) in shopItem.shoppingCartGoodsInfoList" :key="index">
                        <div class="tui-goods-item">
                            <div class="flex">
                                <img :src="require('@/assets/icon/icon_card.png')" class="tui-goods-img" />
                                <div class="tui-goods-center">
                                    <div>
                                        <div class="tui-goods-name">
                                            {{ productList[0].productList[0].productName }}
                                        </div>
                                        <div class="tui-goods-attr">
                                            {{ productList[0].productList[0].cardNo }}
                                        </div>
                                    </div>
                                    <!--<div><span class="tag">限时秒杀</span></div>-->
                                    <div class="tui-price-right">
                                        <div class="goods-price">
                                            {{ productList[0].point }}
                                        </div>
                                        <div>x1</div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="tui-goods-bottom">
                  <span>不支持7天无理由退换货</span>
                </div> -->
                        </div>
                    </div>
                </div>

                <div class="bg-white tui-top round-20">
                    <div class="tui-padding tui-flex">
                        <div>商品总额</div>
                        <div>{{ productList[0].point }}</div>
                    </div>
                    <!-- <div class="tui-padding tui-flex">
                        <div class="flex align-center">
                            <span class="padding-right-xs">运费</span>
                            <van-icon class="icon-box-img" name="warn" size="16" color="#C9C9C9" @click="showModal('freight')"></van-icon>
                        </div>
                        <div>￥0.00</div>
                    </div> -->
                    <div class="tui-padding tui-flex" v-if="this.OrderCount < 1">
                        <div>请输入验证码</div>
                        <div>
                            <input class="tui-input" type="number" v-model="code" />
                        </div>
                        <van-button round block color="var(--theme-color-main)" :disabled="disabled" type="primary" @click="sendcode" class="huoqu">{{ vocode }}</van-button>

                        <!-- <div class="huoqu" @click="sendMsg">获取验证码</div> -->
                    </div>
                </div>

                <!-- <div class="tui-padding tui-flex bg-white tui-top round-20" @click="invoice">
                    <div>开具发票</div>
                    <div class="flex align-center">
                        <span class="pay-price padding-right-xs" v-if="invoiceType == 0">无需发票</span>
                        <span class="pay-price padding-right-xs" v-if="invoiceType == 1">电子发票</span>
                        <span class="pay-price padding-right-xs" v-if="invoiceType == 2">纸质发票</span>
                        <img src="@/assets/icon/right.png" class="right-image" />
                    </div>
                </div> -->
                <div class="tui-zhuyi tui-top">注意事项：</div>

                <div class="tui-padding tui-flex bg-white tui-top round-20">
                    <div class="flex align-center">
                        <van-icon name="checked" size="23" color="#D80C18" v-if="agreement" @click="agreementBind"></van-icon>
                        <van-icon name="circle" size="23" color="#C9C9C9" v-if="!agreement" @click="agreementBind"></van-icon>
                        <span class="padding-left-xs">兑换后非商品质量问题不予退换货，预计7个工作日内发出，勾选表示已同意该条款，感谢理解。</span>
                        <!-- <span class="text-blue" @click="goProtocol">《用户购买协议》</span> -->
                    </div>
                </div>
            </div>
        </div>

        <div class="tui-tabbar">
            <!--<div class="reminder">订单中包含秒杀商品，请在15:00内完成订单</div> -->
            <div class="flex justify-between align-center" style="padding: 10px 0">
                <div class="padding-left" style="text-align: right">
                    <div class="tui-black">
                        <span>实付金额: </span>
                        <span class="tui-price-large">{{ productList[0].point }}</span>
                    </div>
                    <!-- <div class="tabbar-discounts">已优惠：{{ discountAmount }}</div> -->
                </div>
                <div class="tui-pr25">
                    <van-button round block color="var(--theme-color-main)" type="primary" @click="subPay">去下单</van-button>
                    <!-- <div @click="subPay" class="btn-pay"></div> -->
                    <van-loading v-if="loading" size="24px" vertical>加载中...</van-loading>
                </div>
            </div>
        </div>
        <van-popup v-model="show" closeable position="bottom">
            <div class="pay-header">
                <span class="pay-title">收银台</span>
                <span class="pay-price">订单总价</span>
                <span class="pay-money">{{ totalPoint }}积分</span>
                <!-- <span class="pay-time">
                    <van-count-down :time="time" format="DD 天 HH 时 mm 分 ss 秒" />
                </span> -->
            </div>
            <!-- <div class="pay-type">
          <div>支付方式</div>
        </div> -->

            <div class="flex justify-center">
                <div class="pay-but" @click="goPay()">
                    确认支付{{ totalPoint }}积分
                </div>
            </div>
        </van-popup>

        <!-- <div
        class="cu-modal bottom-modal"
        :class="modalName == 'freight' ? 'show' : ''"
        @click="hideModal"
        catchtouchmove="true"
      >
        <div class="cu-dialog bg-white" style="height: 50vh">
          <div class="pay-header">
            <span class="pay-title">运费</span>
          </div>
          <template v-for="shopItem in shopInfo.shoppingCartSubInfoList">
            <div
              class="freight"
              v-for="(
                shopItemProduct, idx
              ) in shopItem.shoppingCartGoodsInfoList"
              :key="idx"
            >
              <span>{{ shopItemProduct.goodsName }}</span>
              <span>运费￥0.00</span>
            </div>
          </template>
          <div class="freight-but" @click="hideModal">我知道了</div>
        </div>
      </div> -->

        <!-- <div
        class="cu-modal bottom-modal"
        :class="modalName == '1' ? 'show' : ''"
        @click="hideModal"
        catchtouchmove="true"
      >
        <div class="cu-dialog bg-white" style="height: 60vh">
          <div class="pay-header">
            <span class="pay-title">您购买的商品在当前区域库存不足</span>
          </div>
          <template v-for="(item, index) in goodsList">
            <div class="goods" :key="index">
              <img
                src="https://g-search2.alicdn.com/img/bao/uploaded/i4/i4/2207433955/O1CN012OSgUT1f5R2AvOjXr_!!2207433955-0-lubanu-s.jpg_580x580Q90.jpg_.webp"
              />
              <span>{{ item.name }}</span>
            </div>
          </template>
          <div class="fixed-bottom">
            <div class="lose-button">
              <div class="confirm">修改收货地址</div>
              <div class="cancel">删除失效商品</div>
            </div>
          </div>
        </div>
      </div> -->
        <!-- <div class="cu-modal" :class="modalName == 'goods' ? 'show' : ''">
        <div class="cu-dialog bg-white">
          <div>
            <div style="padding: 50px 40px">
              您购买的商品价格发生了变化请重新确认
            </div>
            <div class="lose-button">
              <div class="confirm" @click="hideModal">修改收货地址</div>
              <div class="cancel" @click="hideModal">删除失效商品</div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
</div>
</template>

<script>
import wx from "weixin-js-sdk";
import {
    placeAnOrder,
    addOrderInfo,
    preOrder,
    searchUserAddrList,
    directSettle,
    queryMyCoupon,
    shoppingCartSettlement,
    createSpikeOrder,
    createJoinGroupOrder,
    selHaierOrderOverdue,
    haierCreateOrder,
    haierOrderCheckArea,
    haierOrderCheckQuantity,
    haierOrderPay,
    sendMsg,
    verifyCodeMemberReceived,
    haierOrderCount,
} from "../../api/api";

// import {
//   createSpikeOrder,
//   addOrderInfo,
//   createJoinGroupOrder,
//   preOrder,
//   queryMyCoupon,
// } from "@/api/api";
// import orderGoods from "@/components/orderGoods.vue";
// import notData from "@/components/notData.vue";
// import orderPopup from "@/components/orderPopup.vue";
// import merge from "webpack-merge";
export default {
    components: {
        // notData,
        // orderGoods,
        // orderPopup,
    },
    data() {
        return {
            loading: false,
            OrderCount: "",
            disabled: false,
            vocode: "发送验证码",
            totaltime: 60,
            code: null,
            parentOrderNo: "", // 父订单编号
            orderNo: "", //子订单编号
            time: 30 * 60 * 60 * 1000,
            show: false,
            catchtouchmove: false,
            productList: [], //商品列表
            totalPoint: 0,
            agreement: true, //服务协议
            hasCoupon: false,
            insufficient: false,
            modalName: "",
            mark: "",
            payList: [{
                    img: "@/assets/icon/wechat.png",
                    title: "微信支付",
                    tips: "",
                },
                {
                    img: "@assets/icon/balance.png",
                    title: "微众银行储蓄卡",
                    tips: "未开通微众银行储蓄卡的用户,点击确认按钮进入微众银行小程序开户",
                },
            ],
            payIndex: 0,
            // freightList: [
            //   {
            //     name: "迪奥（Dior）烈焰蓝金口红哑光… ",
            //     money: "423.00",
            //   },
            //   {
            //     name: "迪奥（Dior）烈焰蓝金口红哑光… ",
            //     money: "423.00",
            //   },
            // ],
            goodsList: [{
                    name: "迪奥（Dior）烈焰蓝金口红哑光… ",
                    money: "423.00",
                },
                {
                    name: "迪奥（Dior）烈焰蓝金口红哑光… ",
                    money: "423.00",
                },
            ],
            invoiceType: 0,
            invoiceId: null,
            deliveryType: true,
            couponAmount: "",
            couponId: "",

            goodsId: "6635",
            goodsNum: "1",
            addressId: "118",
            groupProductType: "0",
            address: [],
            addressIndex: 0,
            shopInfo: {
                buyTotalAmount: 923,
                couponTotalAmount: 0,
                discountTotalAmount: 0,
                goodIds: [],
                logisticsAmount: 0,
                productPropertyResponses: [{
                        attrId: "2",
                        attrName: "尺寸 ",
                        valueId: "8",
                        valueName: "M",
                    },
                    {
                        attrId: "1",
                        attrName: "颜色",
                        valueId: "6",
                        valueName: "红色",
                    },
                ],
                receiverAddress: "",
                receiverCityId: "0",
                receiverCityName: "",
                receiverCountryId: "0",
                receiverName: "",
                receiverPhone: "",
                receiverProvinceId: "0",
                receiverProvinceName: "",
                receiverRegionName: "朝阳区11",
                saleTotalAmount: 923,
                settleNum: "2020120920180200003700034",
                shoppingCartId: "80772020120815105200003700004",
                shoppingCartSubInfoList: [{
                    deptId: "298",
                    merchantId: "298",
                    merchantName: "",
                    shoppingCartChildrenId: "109",
                    shoppingCartGoodsInfoList: [{
                        buyUnitPrice: 923,
                        couponAmount: 0,
                        couponId: [],
                        discountUnitPrice: 0,
                        goodsId: "6635",
                        goodsName: "苹果iPhone12 Pro Max",
                        goodsNum: 1,
                        goodsUrl: "https://wbstatic.dreamane.com/20201130/20201130_cc4bf523a338acbb537fd620bac2dd8e.jpg",
                        groupType: 0,
                        productPropertyValue: null,
                        promotionId: "",
                        promotionType: 0,
                        saleUnitPrice: 923,
                        selected: true,
                        thirdProductCode: "",
                    }, ],
                    storeId: "109",
                    storeLogoUrl: "http://139.217.220.198:8095/images/20200509/20200509_d5d5ddc90655fc5fa13aeffc310a2105.jpg",
                    storeName: "小米-美罗城店",
                    subBuyTotalAmount: 923,
                }, ],
                token: "",
                userId: "117442",
                buyPayAmount: 360,
            },
            property: "M,红色",
            discountAmount: 0.0,
        };
    },
    mounted() {
        this.addressIndex = this.$store.state.address;
        this.searchUserAddrList();
        this.saleTotalAmount = this.$route.query.saleTotalAmount;
        // this.selHaierOrderOverdue();

        this.orderInit();
        this.haierOrderCount();

        this.saleTotalAmount = this.$route.query.saleTotalAmount;
        this.selHaierOrderOverdue();
    },
    methods: {
        orderInit() {
            this.productList = JSON.parse(
                decodeURIComponent(this.$route.query.productList)
            ); //获取路由参数
            console.log(this.productList);
            this.productList[0].num = "1";
            this.productList[0].point = "定制卡支付";
        },

        // 查看服务协议
        goProtocol() {
            // https://wbh5.dreamane.com/#/my/serviceAgreement
            // wx.miniProgram.navigateTo({
            //   url:
            //     "/pages/cashier/cashier?amount=" +
            //     that.data.shopInfo.buyPayAmount +
            //     "&orderNo=" +
            //     res.data,
            // });
            this.$router.push({
                path: "/my/serviceAgreement",
            });
        },
        //查询用户地址列表
        async searchUserAddrList() {
            let params = {
                token: "a756dd83d7fb496f84398003ad031361",
            };
            let res = await searchUserAddrList(params);
            console.log(res);
            if (res.code == "0000") {
                if (res.data[0] == null) {
                    this.address = [];
                } else {
                    this.address = res.data;
                }
            }
        },
        //自然月短信校验
        async haierOrderCount() {
            let params = {
                buyerId: this.$cookies.get("memberId") || sessionStorage.getItem('memberId'),
            };
            let res = await haierOrderCount(params);
            if (res.code == "0000") {
                this.OrderCount = res.data;
                console.log(this.OrderCount);
            }
        },
        //查询优惠券信息
        async queryCouponPerSon() {
            const param = {
                limit: 10,
                start: 1,
                status: 1,
            };
            const res = await queryMyCoupon(param);
            if (res.code == "0000") {
                this.hasCoupon = true;
                this.couponAmount = "去选择优惠券";
            } else {
                this.$toast(res.msg);
            }
        },
        /**
         * Puxigui
         * 切换地址
         * 2:14 2020/11/20
         */
        tabAddress() {
            var params = {
                goodsId: this.goodsId,
                goodsNum: this.goodsNum,
                couponId: this.couponId,
            };
            if (this.addressId) {
                // url = url + '&addressId=' + this.addressId;
                params.addressId = this.addressId;
            }
            // wx.navigateTo({
            //     url: '../../pages/web-view/web-view?' + "src=" + encodeURIComponent(url)
            // })
            this.$router.push({
                path: "/orders/shippingAddress",
                query: {
                    ...params,
                },
            });
        },
        showModal(name) {
            this.modalName = name;
        },
        toMyCoupon() {
            if (this.hasCoupon) {
                this.$router.push({
                    path: "/my/orderCoupon",
                    query: {
                        goodsId: this.goodsId,
                        goodsNum: this.goodsNum,
                        totalAmount: this.shopInfo.buyTotalAmount,
                        addressId: this.addressId,
                    },
                });
            }
        },
        invoice() {
            const that = this;
            this.$router.push({
                path: "/orders/invoice",
                query: {
                    goodsId: that.goodsId,
                    goodsNum: that.goodsNum,
                    addressId: that.addressId,
                    couponId: that.couponId,
                },
            });
        },
        sendcode() {
            this.totaltime = 60;
            this.timer();
            this.sendMsg();
        },
        timer() {
            if (this.totaltime > 0) {
                this.disabled = true;
                this.totaltime--;
                this.vocode = this.totaltime + "s后重新发送";
                setTimeout(this.timer, 1000);
            } else {
                this.totaltime = 0;
                this.vocode = "重新发送验证码";
                this.disabled = false;
                console.log("1212");
            }
            // this.sendMsg();
            // let clock = window.setInterval(() => {
            //     this.totaltime--
            //     this.vocode = this.totaltime + 's后重新发送'
            //     if (this.totaltime == 0) {
            //         window.clearInterval(clock)
            //         this.vocode = '重新发送验证码'
            //         this.totaltime = 60
            //     }
            // }, 1000)
        },
        //发送验证码
        async sendMsg() {
            const param = {
                memberId: this.$cookies.get("memberId") || sessionStorage.getItem('memberId'),
                msgParameter: {
                    code: this.code,
                },
                phoneNo: this.$cookies.get("memberPhone") || sessionStorage.getItem('memberPhone'),
                sysMessageTemplateId: 1,
            };
            const res = await sendMsg(param);
            if (res.code == "0000") {
                this.$toast("发送成功");
            }
        },
        agreementBind() {
            this.agreement = !this.agreement;
        },
        async subPay() {
            //验证验证码
            if (this.OrderCount < 1) {
                const param = {
                    key: (this.$cookies.get("memberPhone") || sessionStorage.getItem('memberPhone')) + "-" + 1 + "-" + this.code,
                    code: this.code,
                };
                const res = await verifyCodeMemberReceived(param);
                if (res.code == "0000") {
                    // this.$toast("验证码正确");
                } else if (this.code == "") {
                    this.$toast("验证码为空");
                    return false;
                } else {
                    this.$toast("验证码错误");
                }
            }
            if (this.address == []) {
                this.$toast("收货地址不能为空");
                return false;
            }
            if (!this.agreement) {
                this.$toast("请选择购买协议");
                return false;
            }
            this.$store.commit('showLoading')

            this.commitOrder();
        },
        hideModal() {
            this.modalName = "";
        },

        //提交订单
        async commitOrder() {
            this.loading = false;
            //检验地区
            let params = {
                productId: this.productList[0].productList[0].id != null ?
                    this.productList[0].productList[0].id : this.productList[0].productList[0].productId, //商品ID

                provinceId: this.address[this.addressIndex].address.province_id, //省份id
                cityId: this.address[this.addressIndex].address.city_id, //市级id
                areaId: this.address[this.addressIndex].address.district_id, //区县id
            };

            let res = await haierOrderCheckArea(params);

            if (res.code != "0000") {
                this.$store.commit('hideLoading')

                this.$message(res.msg);
                return;
            }
            this.$store.commit('hideLoading')
            this.$store.commit('showLoading')

            params = {
                cardPassword: this.productList[0].productList[0].cardPassword, //卡密， 必

                cardNo: this.productList[0].productList[0].cardNo, //积分卡号， 必
                //type: "", //订单类型
                productId: this.productList[0].productList[0].productId, //兑换产品ID， 必
                //orderTerminal: "", //下单终端
                orderRemark: this.mark, //订单留言， 必
                //userId: "", //下单用户ID
                num: "1", //购买数量，1,必
                productName: this.productList[0].productList[0].productName, //商品名称， 必
                //userName: "", //用户名称
                recipientsName: this.address[this.addressIndex].receiver_name, //收货人姓名， 必
                recipientsAddr: this.address[this.addressIndex].address.line1, //收货详细地址， 必
                cityCode: this.address[this.addressIndex].address.city_id, //市区的编码， 必
                city: this.address[this.addressIndex].address.city, //市区名称， 必
                province: this.address[this.addressIndex].address.province, //省名称， 必
                provinceCode: this.address[this.addressIndex].address.province_id, //省编码， 必
                areaCode: this.address[this.addressIndex].address.district_id, //区/县编码， 必
                area: this.address[this.addressIndex].address.district, //区/县名称， 必
                recipientsPhone: this.address[this.addressIndex].receiver_mobile, //收货人电话， 必
                token: "a756dd83d7fb496f84398003ad031361", //用户级token， 必
            };

            console.log(params);

            res = await placeAnOrder(params);
            if (res.code == "0000") {
                // this.show = true;
                this.$toast("下单成功");
                setTimeout(() => {
                    this.$router.push({
                        path: "/order",
                    });
                }, 1000);
                this.$store.commit('hideLoading')

            } else {
                this.$toast(res.msg);
                this.$store.commit('hideLoading')

            }
            this.$store.commit('hideLoading')

        },

        //立即付款
        async goPay() {
            let params = {
                buyerId: this.$cookies.get("memberId") || sessionStorage.getItem('memberId'),
                payTotalAmount: this.totalPoint,
                parentOrderNo: this.parentOrderNo,
                phone:this.$cookies.get("memberPhone") || sessionStorage.getItem('memberPhone'),
            };

            const res = await haierOrderPay(params);
            if (res.code === "0000") {
                this.$toast("支付成功");
                setTimeout(() => {
                    this.$router.push({
                        path: "/order",
                    });
                }, 1000);
            } else {
                this.$toast(res.msg);
            }
        },

        //订单过期时间
        // async selHaierOrderOverdue() {
        //     console.log("1111111")
        //     let params = {
        //         orderNo: this.orderNo,
        //     }

        //     const res = await selHaierOrderOverdue(params);
        //     if (res.code == "0000") {
        //         console.log(res)
        //     }
        // },

        // goWebview() {
        //   var that = this;
        //   //调用下单接口
        //   var param = {};
        //   param.couponIds = [""];
        //   param.settleNum = this.shopInfo.settleNum;
        //   param.shoppingCartId = this.shopInfo.shoppingCartId;
        //   param.receiverProvinceName = this.address.addressProvinceId;
        //   param.receiverCityName = this.address.addressCityId;
        //   param.receiverRegionName = this.address.addressRegionId;
        //   param.receiverName = this.address.consigneeName;
        //   param.receiverPhone = this.address.phone;
        //   param.receiverAddress = this.address.addressDetail;
        //   param.invoiceId = this.invoiceId;
        //   param.actualPayTotalAmount = this.shopInfo.buyPayAmount;
        //   param.saleTotalAmount = this.shopInfo.buyTotalAmount;
        //   param.discountTotalAmount = this.discountAmount;
        //   //如果是秒杀商品，发起请求生成秒杀订单，如果是拼团，发起拼团订单，否则生成普通商品订单
        //   if (this.orderType == "seckill") {
        //     param.buyTotalAmount = this.shopInfo.buyTotalAmount;
        //     param.actualPayTotalAmount = this.shopInfo.buyPayAmount;
        //     param.buyNum = this.goodsNum;
        //     param.mpId = this.goodsId;
        //     param.promotionId = this.promotionId;
        //     param.promotionType = 4;
        //     createSpikeOrder(param, function (res) {
        //       if (res.code == "0000") {
        //         wx.miniProgram.navigateTo({
        //           url:
        //             "/pages/cashier/cashier?amount=" +
        //             that.data.shopInfo.buyPayAmount +
        //             "&orderNo=" +
        //             res.data,
        //         });
        //       }
        //     });
        //   } else if (this.orderType == "group") {
        //     param.buyTotalAmount = this.shopInfo.buyTotalAmount;
        //     param.actualPayTotalAmount = this.shopInfo.buyPayAmount;
        //     param.buyNum = this.goodsNum;
        //     param.goodsId = this.goodsId;
        //     param.groupId = this.groupId;
        //     param.groupInstCode = this.groupInstCode;
        //     param.launchFlag = this.groupType;
        //     param.promotionType = this.promotionType;
        //     createJoinGroupOrder(param, function (res) {
        //       if (res.code == "0000") {
        //         if (that.shopInfo.buyPayAmount == 0) {
        //           setTimeout(() => {
        //             that.$router.push({
        //               path: "/orders/paymentSuccessful",
        //             });
        //           }, 1000);
        //         } else {
        //           wx.miniProgram.navigateTo({
        //             url:
        //               "/pages/cashier/cashier?amount=" +
        //               that.shopInfo.buyPayAmount +
        //               "&orderNo=" +
        //               res.data,
        //           });
        //         }
        //       }
        //     });
        //   } else {
        //     param.couponIds = [this.couponId];
        //     addOrderInfo(param).then((res) => {
        //       wx.miniProgram.redirectTo({
        //         url:
        //           "/pages/cashier/cashier?amount=" +
        //           that.shopInfo.buyPayAmount +
        //           "&orderNo=" +
        //           res.data +
        //           "&payType=" +
        //           this.shopInfo.payMeent,
        //       });
        //     });
        //   }
        // },

        /**
         * Puxigui
         *  查询用户地址信息
         * 19:06 2020/11/19
         */
        // async queryUserAddress() {
        //   let that = this;
        //   const param = {
        //     start: 1,
        //     limit: 10,
        //     id: this.addressId,
        //   };
        //   const res = await searchUserAddrList(param);
        //   if (res.code == "0000") {
        //     if (res.data.rows) {
        //       if (this.addressId) {
        //         res.data.rows.forEach(function (item) {
        //           if (item.id == that.addressId) {
        //             that.address = item;
        //             that.addressId = item.id;
        //           }
        //         });
        //       }
        //       res.data.rows.forEach(function (item) {
        //         if (item.isDefault == 1) {
        //           that.address = item;
        //           that.addressId = item.id;
        //         }
        //       });
        //       if (!this.addressId) {
        //         (this.address = res.data.rows[0] ? res.data.rows[0] : ""),
        //           (this.addressId = res.data.rows[0].id);
        //       }
        //     }
        //   } else {
        //     this.$toast(res.msg);
        //   }
        // },
        /**
         * Puxigui
         *  查询购物车下单信息
         * 19:32 2020/11/19
         */
        async queryProductInfo() {
            const param = {};
            const res = await shoppingCartSettlement(param);
            if (res.code == "0000") {
                this.shopInfo = res.data;
                this.shopInfo.buyPayAmount = res.data.buyTotalAmount;
            } else {
                this.$toast(res.msg);
            }
        },

        /**
         * Puxigui
         * 直接下单
         * 14:47 2020/11/20
         */
        async directSettle() {
            const param = {
                goodsId: this.goodsId,
                goodsNum: this.goodsNum,
                promotionId: this.promotionId,
                promotionType: this.promotionType,
                groupType: this.groupType,
                saleUnitPrice: this.saleUnitPrice,
            };
            if (this.promotionId && !param.groupType) {
                param.couponIds = [param.promotionType];
            }
            const res = await directSettle(param);
            if (res.code == "0000") {
                this.shopInfo = res.data;
                this.shopInfo.buyPayAmount = res.data.buyTotalAmount;
                if (res.data.productPropertyResponses) {
                    var property = [];
                    res.data.productPropertyResponses.forEach(function (item) {
                        property.push(item.valueName);
                    });
                    this.property = property.join(",");
                }
                // this.preOrder();
            } else {
                this.$toast(res.msg);
            }
        },
        //商品预计算
        async preOrder() {
            var this_ = this;
            var array = [];
            if (this_.shopInfo && this_.shopInfo.shoppingCartSubInfoList) {
                this_.shopInfo.shoppingCartSubInfoList.forEach(function (item) {
                    item.shoppingCartGoodsInfoList.forEach(function (item2) {
                        var obj = {};
                        obj.productId = item2.goodsId;
                        obj.num = item2.goodsNum;
                        array.push(obj);
                    });
                });
            }
            const param = {
                couponId: this.data.couponId,
                isCart: 1,
                productOrders: array,
            };
            const res = await preOrder(param);
            if (res.code == "0000") {
                (this.shopInfo.buyPayAmount = res.data.payAmount),
                (this.shopInfo.buyTotalAmount = res.data.totalAmount),
                (this.discountAmount = res.data.discountAmount);
                if (this.couponId && "undefined" != this.couponId) {
                    this.couponAmount = "-" + res.data.couponAmount;
                }
            } else {
                this.$toast(res.msg);
            }
        },
    },
    destroyed() {},
    created: function () {
        // if (this.$route.query.token) {
        //     this.$cookies.set("token", this.$route.query.token);
        // }
        // if (this.$route.query.address) {
        //     this.$cookies.set("address", this.$route.query.address);
        // }
        // this.address = JSON.parse(this.$cookies.get("address"));
    },
};
</script>

<style lang="scss" scoped>
.huoqu {
    width: 260px;
}

.tui-input {
    border: 1px solid #666;
    width: 180px;
    height: 60px;
    padding-left: 20px;
}

.tui-zhuyi {
    padding-left: 20px;
    font-size: 27px;
}

/**app.wxss**/

// .app {
$--themeColor: #ff5033;
$--themeColors: #d80c18;
$--themeColor2: #d80c18;
$--myColor: #1e53a4;

// }
.text-theme {
    --themeColor: #ff5033;
    --themeColor2: #d80c18;
}

.container {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 200rpx 0;
    box-sizing: border-box;
}

/* ==================
          布局
 ==================== */

/*  -- flex弹性布局 -- */

.flex {
    display: flex;
}

.basis-xs {
    flex-basis: 20%;
}

.basis-sm {
    flex-basis: 40%;
}

.basis-df {
    flex-basis: 50%;
}

.basis-lg {
    flex-basis: 60%;
}

.basis-xl {
    flex-basis: 80%;
}

.flex-sub {
    flex: 1;
}

.flex-twice {
    flex: 2;
}

.flex-treble {
    flex: 3;
}

.flex-direction {
    flex-direction: column;
}

.flex-wrap {
    flex-wrap: wrap;
}

.align-start {
    align-items: flex-start;
}

.align-end {
    align-items: flex-end;
}

.align-center {
    align-items: center;
}

.align-stretch {
    align-items: stretch;
}

.self-start {
    align-self: flex-start;
}

.self-center {
    align-self: flex-center;
}

.self-end {
    align-self: flex-end;
}

.self-stretch {
    align-self: stretch;
}

.align-stretch {
    align-items: stretch;
}

.justify-start {
    justify-content: flex-start;
}

.justify-end {
    justify-content: flex-end;
}

.justify-center {
    justify-content: center;
}

.justify-between {
    justify-content: space-between;
}

.justify-around {
    justify-content: space-around;
}

/* ==================
         模态窗口
 ==================== */

// .cu-modal {
//   position: fixed;
//   top: 0;
//   right: 0;
//   bottom: 0;
//   left: 0;
//   z-index: 1110;
//   opacity: 0;
//   outline: 0;
//   text-align: center;
//   -ms-transform: scale(1.185);
//   transform: scale(1.185);
//   backface-visibility: hidden;
//   perspective: 2000rpx;
//   background: rgba(0, 0, 0, 0.6);
//   transition: all 0.3s ease-in-out 0s;
//   pointer-events: none;
// }

// .cu-modal::before {
//   content: "\200B";
//   display: inline-block;
//   height: 100%;
//   vertical-align: middle;
// }

// .cu-modal.show {
//   opacity: 1;
//   transition-duration: 0.3s;
//   -ms-transform: scale(1);
//   transform: scale(1);
//   overflow-x: hidden;
//   overflow-y: auto;
//   pointer-events: auto;
// }

// .cu-dialog {
//   position: relative;
//   display: inline-block;
//   vertical-align: middle;
//   margin-left: auto;
//   margin-right: auto;
//   width: 610rpx;
//   max-width: 100%;
//   background-color: #f8f8f8;
//   border-radius: 20rpx;
//   overflow: hidden;
// }

// .cu-modal.bottom-modal::before {
//   vertical-align: bottom;
// }

// .cu-modal.bottom-modal .cu-dialog {
//   width: 100%;
//   border-radius: 20rpx;
// }

// .cu-modal.bottom-modal {
//   margin-bottom: -1000rpx;
// }

// .cu-modal.bottom-modal.show {
//   margin-bottom: 0;
// }

// .cu-modal.drawer-modal {
//   transform: scale(1);
//   display: flex;
// }

// .cu-modal.drawer-modal .cu-dialog {
//   height: 100%;
//   min-width: 200rpx;
//   border-radius: 0;
//   margin: initial;
//   transition-duration: 0.3s;
// }

// .cu-modal.drawer-modal.justify-start .cu-dialog {
//   transform: translateX(-100%);
// }

// .cu-modal.drawer-modal.justify-end .cu-dialog {
//   transform: translateX(100%);
// }

// .cu-modal.drawer-modal.show .cu-dialog {
//   transform: translateX(0%);
// }

// .cu-modal .cu-dialog > .cu-bar:first-child .action {
//   min-width: 100rpx;
//   margin-right: 0;
//   min-height: 100rpx;
// }
.colon {
    display: inline-block;
    margin: 0 4px;
    color: #ee0a24;
}

.block {
    display: inline-block;
    width: 52px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    background-color: #ee0a24;
}

// ------------------------------
// .containers {
//     background-color: #f5f6f5;
// }

.bg-white {
    background-color: #ffffff;
}

.round-20 {
    border-radius: 20px;
}

.tui-box {
    padding: 0 0 158px;
    box-sizing: border-box;
}

.padding-right-xs {
    padding-right: 10px;
}

.tips {
    font-size: 24px;
    width: 70%;
    text-align: left;
    padding: 24px;
    color: #999999;
    height: 120px;
}

.tui-address {
    min-height: 170px;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    background-color: #fff;
    position: relative;
}

.address-image {
    width: 60px;
    height: 60px;
    margin-right: 20px;
}

.right-image {
    width: 15px;
    height: 26px;
}

.address-main {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.tui-userinfo {
    font-size: 36px;
    font-weight: 500;
    color: #333;
    padding-bottom: 12px;
}

.tui-name {
    padding-right: 40px;
}

.tui-addr {
    font-size: 26px;
    word-break: break-all;
    color: #666;
    width: 534px;
    height: 61px;
}

.tui-addr-tag {
    padding: 5px 8px;
    flex-shrink: 0;
    background: #eb0909;
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 25px;
    line-height: 25px;
    transform: scale(0.8);
    transform-origin: 0 center;
    border-radius: 6px;
}

.tui-bg-img img {
    width: 100%;
    height: 8px;
    position: absolute;
    bottom: -10px;
    left: 0;
}

.tui-top {
    margin-top: 20px;
    overflow: hidden;
}

.tui-goods-info {
    margin: 30px 20px;
}

.tui-goods-title {
    font-size: 26px;
    display: flex;
    align-items: center;
    color: #333333;
    padding: 20px 0 0 20px;
}

.tui-padding {
    padding: 30px 20px;
}

.tui-goods-item {
    width: 100%;
    padding: 20px 30px;
    box-sizing: border-box;
}

.tui-goods-img {
    width: 180px;
    height: 180px;
    display: block;
    flex-shrink: 0;
    border-radius: 10px;
}

.tui-goods-center {
    flex: 1;
    padding-left: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.tui-goods-name {
    max-width: 90%;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    font-size: 26px;
    line-height: 32px;
    color: #333333;
}

.tui-goods-attr {
    font-size: 22px;
    color: #888888;
    padding-top: 5px;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}

.tui-price-right {
    font-size: 26px;
    color: #666666;
    display: flex;
    justify-content: space-between;
}

.goods-price {
    font-size: 32px;
    font-weight: 500;
}

.tui-goods-bottom {
    margin-left: 200px;
    font-size: 20px;
    color: #999999;
    margin-top: 20px;
}

.tui-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 26px;
}

.tui-pr-30 {
    padding-right: 30px;
}

.tui-addr-img {
    width: 36px;
    height: 46px;
    display: block;
    margin-right: 15px;
}

.tui-black {
    color: #333;
    line-height: 30px;
}

.tui-price-large {
    font-size: 34px;
    line-height: 32px;
    font-weight: 600;
    color: $--themeColors;
}

.tui-price-large::before {
    font-size: 20px;
    color: $--themeColors;
}

/* 底部 */
.tui-tabbar {
    width: 100%;
    background: #fff;
    position: fixed;
    left: 0;
    bottom: 0;
    font-size: 26px;
    padding-bottom: env(safe-area-inset-bottom);
    z-index: 999;
}

.reminder {
    height: 70px;
    background: #fdf1f1;
    font-size: 26px;
    color: $--themeColors;
    line-height: 70px;
    padding-left: 20px;
}

.tabbar-discounts {
    font-size: 20px;
    color: #666666;
}

.tui-pr25 {
    padding-right: 30px;
}

.text-blue {
    color: #758dbf;
}

.padding-left {
    padding-left: 20px;
}

.btn-pay {
    width: 226px;
    height: 76px;
    background: $theme-color-main;
    border-radius: 38px;
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    color: #ffedf3;
    line-height: 76px;
}

/* 支付弹框 */
.pay-header {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.pay-type {
    height: 100px;
    border-bottom: 1px solid #e5e5e5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 24px;
    font-size: 26px;
    color: #333333;
}

.pay-title {
    font-size: 28px;
    padding: 22px 0 40px 0;
}

.pay-price {
    font-size: 26px;
    color: #999999;
}

.pay-money {
    font-size: 46px;
    padding: 20px;
}

.pay-time {
    font-size: 26px;
    color: $--themeColor;
}

.pay-but {
    width: 580px;
    height: 88px;
    background: $theme-color-main;
    border-radius: 43px;
    font-size: 28px;
    text-align: center;
    color: #ffffff;
    line-height: 88px;
    margin-top: 200px;
    margin-bottom: 30px;
}

.pay-icon {
    width: 50px;
    height: 50px;
    margin-right: 10px;
}

.tag {
    background: #fdf1f1;
    border-radius: 5px;
    font-size: 20px;
    color: $--themeColors;
    padding: 2px 5px;
}

/* 运费 */
.freight {
    display: flex;
    justify-content: space-between;
    font-size: 26px;
    color: #333333;
    padding: 20px;
}

.freight-but {
    width: 750px;
    height: 88px;
    background: $--themeColors;
    font-size: 36px;
    text-align: center;
    color: #ffffff;
    line-height: 88px;
    position: fixed;
    bottom: 0;
    padding-bottom: env(safe-area-inset-bottom);
}

/* 失效商品 */
.goods {
    display: flex;
    align-items: center;
    font-size: 26px;
    color: #333333;
    padding: 20px;
}

.goods img {
    width: 115px;
    height: 115px;
    border-radius: 10px;
}

.goods text {
    margin-left: 26px;
}

.lose-button {
    display: flex;
    border-top: 1px solid #dddddd;
}

.confirm {
    padding: 30px;
    color: #ffffff;
    background: $--themeColors;
    flex: 1;
}

.cancel {
    padding: 30px;
    flex: 1;
}

.fixed-bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
}

.tui-none-addr {
    font-size: 26px;
    color: #666666;
}
</style>
